import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";
import { attempt } from "../../../../service/apiResult";

const apiService = new ApiService();

// EK-02: DARE sign-up approvals. eKutir decides the DAREs whose country had no Ecosystem
// Integrator; the rest are listed read-only (their integrator decides them).

export const listDareApprovals = async ({ status, approverType, search, page = 0, size = 20 }) => {
  const params = new URLSearchParams({ page: String(page), size: String(size) });
  if (status) params.append('status', status);
  if (approverType) params.append('approverType', approverType);
  if (search && search.trim()) params.append('search', search.trim());
  try {
    const response = await apiService.get(`${apiEndPoints.dareApprovals}?${params.toString()}`);
    return { statusCode: 200, data: response.data };
  } catch (error) {
    // The axios interceptor rejects with a plain { statusCode, message }.
    return { statusCode: error?.statusCode || 500, message: error?.message || 'Failed to load DARE requests' };
  }
};

export const getDareApproval = async (dareUserId) =>
  attempt(async () => (await apiService.get(`${apiEndPoints.dareApprovals}/${dareUserId}`)).data);

export const decideDareApproval = async (dareUserId, body) =>
  attempt(() => apiService.post(`${apiEndPoints.dareApprovals}/${dareUserId}/decision`, body));

export const reopenDareApproval = async (dareUserId, comment) =>
  attempt(() => apiService.post(`${apiEndPoints.dareApprovals}/${dareUserId}/reopen`, { comment }));

// EK-03: a DARE's subscription and payments. Billing is eKutir's area only.
export const getDareSubscription = async (dareUserId) =>
  attempt(async () => (await apiService.get(`${apiEndPoints.dareApprovals}/${dareUserId}/subscription`)).data);

export const recordDareManualPayment = async (dareUserId, transactionReference) =>
  attempt(() => apiService.post(`${apiEndPoints.dareApprovals}/${dareUserId}/subscription/manual-payment`, { transactionReference }));

/** Every DARE's sign-up approval, keyed by DARE user id, for the User Onboarding list. */
export const listAllDareApprovals = async () =>
  attempt(async () => {
    const size = 200;
    const byUser = {};
    for (let page = 0; ; page += 1) {
      const params = new URLSearchParams({ page: String(page), size: String(size) });
      // eslint-disable-next-line no-await-in-loop
      const response = await apiService.get(`${apiEndPoints.dareApprovals}?${params.toString()}`);
      const content = response.data?.content || [];
      content.forEach((approval) => {
        byUser[approval.dareUserId] = approval;
      });
      if (content.length < size || (page + 1) * size >= (response.data?.totalElements || 0)) break;
    }
    return byUser;
  });
